import React, { Children } from 'react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
import { HeadphonesIcon, BookOpenIcon, SmartphoneIcon, ShieldIcon } from 'lucide-react';
export function DeliverablesSection() {
  return <AnimatedSection staggerChildren className="py-16 md:py-24 px-6 max-w-4xl mx-auto" data-id="element-41">
      <div className="text-center mb-16" data-id="element-42">
        <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-43">
          Lo Que Recibes
        </h2>
        <p className="text-lg text-charcoal/70" data-id="element-44">
          Todo lo que necesitas para recuperar el control.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-45">
        <AnimatedItem data-id="element-46">
          <div className="bg-cream rounded-xl p-8 border border-charcoal/5 h-full" data-id="element-47">
            <div className="bg-warmBg w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-48">
              <HeadphonesIcon className="w-8 h-8 text-sage" data-id="element-49" />
            </div>
            <h3 className="text-xl font-bold text-charcoal mb-3 font-heading" data-id="element-50">
              Audio-Guía de Rescate Inmediato
            </h3>
            <p className="text-charcoal/70 leading-relaxed" data-id="element-51">
              El audio que pones en tus audífonos cuando sientes que la crisis
              empieza para recuperar el aire al instante.
            </p>
          </div>
        </AnimatedItem>

        <AnimatedItem data-id="element-52">
          <div className="bg-cream rounded-xl p-8 border border-charcoal/5 h-full" data-id="element-53">
            <div className="bg-warmBg w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-54">
              <BookOpenIcon className="w-8 h-8 text-sage" data-id="element-55" />
            </div>
            <h3 className="text-xl font-bold text-charcoal mb-3 font-heading" data-id="element-56">
              El Manual "Controla tu Ansiedad" (PDF)
            </h3>
            <p className="text-charcoal/70 leading-relaxed" data-id="element-57">
              El mapa visual de los puntos de presión y reseteos térmicos para
              usar en el trabajo o el auto sin que nadie lo note.
            </p>
          </div>
        </AnimatedItem>

        <AnimatedItem data-id="element-58">
          <div className="bg-cream rounded-xl p-8 border border-charcoal/5 h-full" data-id="element-59">
            <div className="bg-warmBg w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-60">
              <SmartphoneIcon className="w-8 h-8 text-sage" data-id="element-61" />
            </div>
            <h3 className="text-xl font-bold text-charcoal mb-3 font-heading" data-id="element-62">
              Tarjeta de Emergencia S.O.S.
            </h3>
            <p className="text-charcoal/70 leading-relaxed" data-id="element-63">
              Una guía visual rápida para guardar en tu celular y usar en tus
              momentos más oscuros.
            </p>
          </div>
        </AnimatedItem>

        <AnimatedItem data-id="element-64">
          <div className="bg-sage/10 rounded-xl p-8 border-2 border-sage/30 h-full relative overflow-hidden" data-id="element-65">
            <span className="absolute top-4 right-4 bg-sage text-white text-xs font-semibold px-2 py-1 rounded-full" data-id="element-66">
              BONUS
            </span>
            <div className="bg-warmBg w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-67">
              <ShieldIcon className="w-8 h-8 text-sage" data-id="element-68" />
            </div>
            <h3 className="text-xl font-bold text-charcoal mb-3 font-heading" data-id="element-69">
              Rutina de Blindaje Diario
            </h3>
            <p className="text-charcoal/70 leading-relaxed" data-id="element-70">
              5 minutos al día para bajar tus niveles base de cortisol y evitar
              que las crisis vuelvan a aparecer.
            </p>
          </div>
        </AnimatedItem>
      </div>
    </AnimatedSection>;
}